export default __webpack_public_path__ + "static/media/ecr.33b45435.svg";